import { useState, useEffect } from "react";
import { GET_BLOG_BY_SLUG } from '../api/constants';

export const useBlogDetails = (slug) => {
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;

    const fetchBlog = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(`${GET_BLOG_BY_SLUG}/${slug}`);
        const data = await response.json();

        if (data.status) {
          setBlog(data.data || null);
        } else {
          setBlog(null);
          setError(data.message || "Blog not found.");
        }
      } catch (err) {
        console.error("Error fetching blog by slug:", err);
        setError("Failed to fetch blog.");
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  return { blog, loading, error };
};
